import { useCallback, useState } from 'react';
import { useAppDispatch, useAppSelector } from '@app/redux/hooks';
import { fieldsAuto, filterActions, getAuto } from '@entities/Filter';

import { MarkType, ModelType, ModificationType, RecommendedSizeByModificationType, YearCurrentType } from '../types/autoSelectsTypes';
import { useSaveAutoParams } from '@shared/hooks/useSaveAutoParams';
import { useRouter } from 'next/router';

interface useManagerAutoSelectsType {
  markCurrent: MarkType;
  modelCurrent: ModelType;
  yearCurrent: string;
  modificationCurrent: ModificationType;
  recommendedSize: RecommendedSizeByModificationType;
  handlerSetMark: (value: MarkType) => void;
  handlerSetModel: (value: ModelType) => void;
  handlerSetYear: (value: YearCurrentType) => void;
  handlerSetModification: (value: ModificationType) => void;
}

export const useManagerAutoSelects = (): useManagerAutoSelectsType => {
  const dispatch = useAppDispatch();
  const { mark: markCurrent, model: modelCurrent, year: yearCurrent, modification: modificationCurrent } = useAppSelector(getAuto);
  useSaveAutoParams();
  const router = useRouter();
  const [recommendedSize, setRecommendedSize] = useState<RecommendedSizeByModificationType>(null);

  const mapValue = (value: string): string => {
    return ['все', '—'].includes(value?.toLowerCase()) ? '' : value;
  };

  const handlerSetMark = useCallback(
    (value: MarkType) => {
      if (markCurrent?.id !== value?.id) {
        dispatch(filterActions.setAuto({ key: fieldsAuto.Mark, value }));
      }
    },
    [markCurrent],
  );

  const handlerSetModel = useCallback(
    (value: ModelType) => {
      if (modelCurrent?.id !== value?.id) {
        dispatch(filterActions.setAuto({ key: fieldsAuto.Model, value }));
      }
    },
    [modelCurrent],
  );

  const handlerSetYear = useCallback(
    (value: YearCurrentType) => {
      if (yearCurrent != value) {
        dispatch(filterActions.setAuto({ key: fieldsAuto.Year, value: mapValue(value) }));
      }
    },
    [yearCurrent],
  );

  const handlerSetModification = useCallback(
    (value: ModificationType) => {
      if (modificationCurrent?.id !== value?.id) {
        dispatch(filterActions.setAuto({ key: fieldsAuto.Modification, value }));
      }
    },
    [modificationCurrent],
  );

  return {
    markCurrent,
    modelCurrent,
    yearCurrent,
    modificationCurrent,
    recommendedSize,
    handlerSetMark,
    handlerSetModel,
    handlerSetYear,
    handlerSetModification,
  };
};
